import * as React from "react";
import { JsonSettingsEdit } from "fe-web-components/settings/presentaional/jsonSettingsEdit";
import { ClinicConfigKeys } from "fe-common/graphql/clinic/clinicConfigKeys";
import { useUpdateClinicConfig } from "./hooks/useUpdateClinicConfig";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { ClinicPageWrapper } from "./elements/clinicPageWrapper";
import { useClinicState } from "../../clinic/clinicStateContext";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicTranslationsProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicTranslations = ({ ...props }: ClinicTranslationsProps) => {
  // TODO: this is just a quick and dirty C&P from ClinicV1Settings, we would probably want to re-orgenize the code,
  //  provide better ui and move all db settings updates to a hook
  const {
    config,
    getDefaultValueFor,
    createStoreKeyHandler,
    createResetDefaultHandler,
    isReady,
  } = useUpdateClinicConfig();

  const [{ isMasterClinic }] = useClinicState();

  // Make sure we update the db settings before letting the users change the settings
  if (!isReady) return <ThreeDotsLoader />;

  return (
    <ClinicPageWrapper pageTitle={"Text Overrides"}>
      <JsonSettingsEdit
        keyName={ClinicConfigKeys.Translations}
        value={
          config[ClinicConfigKeys.Translations] ||
          getDefaultValueFor(ClinicConfigKeys.Translations)
        }
        onSubmit={createStoreKeyHandler(ClinicConfigKeys.Translations)}
        onResetDefaultClicked={createResetDefaultHandler(
          ClinicConfigKeys.Translations,
        )}
        isMasterClinic={isMasterClinic}
        open
      />
    </ClinicPageWrapper>
  );
};
